// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js!../../button/style/index.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*simone todo use inline svg*/
:host([icon="lens"]) .button {
    width: 60px;
    height: 60px;
}

:host([icon]) .swiftref-button::after {
    margin-left: unset;
}

:host([size="lg"]) .swiftref-button {
    padding: var(--spacing-10) var(--custom-spacing-30);
}
`, "",{"version":3,"sources":["webpack://./../website_design_system/src/components/icon_button/style/index.css"],"names":[],"mappings":"AAGA,6BAA6B;AAC7B;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mDAAmD;AACvD","sourcesContent":["@import '../../button/style/index.css';\n\n\n/*simone todo use inline svg*/\n:host([icon=\"lens\"]) .button {\n    width: 60px;\n    height: 60px;\n}\n\n:host([icon]) .swiftref-button::after {\n    margin-left: unset;\n}\n\n:host([size=\"lg\"]) .swiftref-button {\n    padding: var(--spacing-10) var(--custom-spacing-30);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
